import { render, staticRenderFns } from "./conducta.vue?vue&type=template&id=581b0c6a"
import script from "./conducta.vue?vue&type=script&lang=js"
export * from "./conducta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports